import { useState } from "react";

export default function useForm({
  initialValues = {},
  onSubmit = () => {},
  validate = () => {},
  validateOnChange = true,
}) {
  const [_initialValues, setInitialValues] = useState(initialValues);
  const [values, setValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { id, value } = event.target;
    setFieldValue(id, value);
    if (validateOnChange) {
      const newValues = Object.assign(values, {
        [id]: value,
      });
      areFieldsValidated(newValues);
    }
  };

  const areFieldsValidated = (values) => {
    const errors = validate(values);
    if (errors && Object.keys(errors).length) {
      setErrors(errors);
      return false;
    } else {
      setErrors({});
      return true;
    }
  };

  const setFieldValue = (field, value) => {
    setValues((previous) =>
      Object.assign(previous, {
        [field]: value,
      })
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (areFieldsValidated(values)) {
      setIsSubmitting(true);
      onSubmit(values);
    }
  };

  const resetForm = (object) => {
    if (object) {
      for (const key in object) {
        setFieldValue(key, object[key]);
      }
    } else {
      setFieldValue("values", _initialValues);
    }
  };

  const setSubmitting = () => {
    setIsSubmitting(false);
  };

  return {
    values,
    errors,
    handleChange,
    setFieldValue,
    handleSubmit,
    resetForm,
    isSubmitting,
    setSubmitting,
  };
}
